import React from "react";
import Form from "./userPersonalInfoForm";

export default ({
  user,
  date,
  handleImageChange,
  imageSrc,
  handleChangeDate,
  handleUpdateUserProfile,
  userLogout,
  isLoading,
}) => {
  return (
    <div>
      {user && (
        <Form
          handleChangeDate={handleChangeDate}
          imageSrc={imageSrc}
          user={user}
          date={date}
          handleImageChange={handleImageChange}
          handleUpdateUserProfile={handleUpdateUserProfile}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};
